import { HttpProxyConfig } from "../types/config";

/** Return a proxied URL when rules match, otherwise the original URL. */
export function proxify(rawUrl: string, cfg?: HttpProxyConfig): string {
  if (!cfg || !cfg.useProxy) return rawUrl;

  // first try explicit rules
  const match = cfg.rules?.find(r => rawUrl.startsWith(r.urlPrefix));
  if (match) return `${match.proxyUrl}?${encodeURIComponent(rawUrl)}`;

  // or force everything through the base proxy if configured
  if (cfg.alwaysUseProxy && cfg.url) {
    return `${cfg.url}?${encodeURIComponent(rawUrl)}`;
  }

  return rawUrl;
}
